// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Heading_wrapper__hq45u","bottomWrapper":"Heading_bottomWrapper__28VFc","btn":"Heading_btn__2d5Eh"};